<template>
  <div class="checkbox">
    <el-form ref="form" label-width="70px" :model="form" :rules="rules">
      <el-form-item label="题干" prop="question">
        <el-input
          v-model="form.question"
          type="textarea"
          :autosize="{ minRows: 1 }"
          resize="none"
          placeholder="请输入题干"
          :readonly="!isEdit"
        />
      </el-form-item>
      <el-form-item label="选项" prop="optionList">
        <b class="tips" style="color: #999" v-show="isEdit"
          >(点击英文字母设置正确答案)</b
        >
        <div class="option" v-for="i in form.optionList" :key="i.tag">
          <span
            class="tag"
            :class="{ checked_tag: isInArray(form.answerList, i.tag) }"
            @click="chooseQuestion(i)"
            >{{ i.tag }}</span
          >
          <el-input
            v-model="i.option"
            type="textarea"
            :autosize="{ minRows: 1 }"
            resize="none"
            placeholder="请输入选项内容"
            class="option_input"
            :readonly="!isEdit"
          />
          <i class="el-icon-delete" v-show="isEdit" @click="delItem(i)"></i>
        </div>
        <el-button
          v-show="isEdit"
          icon="el-icon-plus"
          @click="addItem"
          size="small"
          style="margin-top: 10px"
          >添加选项</el-button
        >
      </el-form-item>
      <el-form-item label="分值" prop="score" v-if="!noScore">
        <el-input-number
          v-model="form.score"
          size="small"
          :min="0"
          :controls="false"
        ></el-input-number>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const textArr = ["A", "B", "C", "D", "E", "F", "G"];
export default {
  name: "checkbox",
  props: {
    form: Object,
    noScore: Boolean,
    isEdit: Boolean,
  },
  data() {
    return {
      rules: {
        question: [
          { required: true, message: "题干不能为空", trigger: "blur" },
        ],
        optionList: [
          { required: true, message: "选项不能为空", trigger: "change" },
        ],
        score: [{ required: true, message: "分值不能为空", trigger: "change" }],
      },
    };
  },
  methods: {
    addItem() {
      let len = this.form.optionList.length;
      let item = {
        tag: "A",
        option: "",
      };
      if (len == 0) {
        item.tag = "A";
      } else if (len == 1) {
        item.tag = "B";
      } else if (len == 2) {
        item.tag = "C";
      } else if (len == 3) {
        item.tag = "D";
      } else if (len == 4) {
        item.tag = "E";
      } else if (len == 5) {
        item.tag = "F";
      } else if (len == 6) {
        item.tag = "G";
      } else {
        this.$message({
          message: "最多添加7个选项",
          type: "warning",
        });
        return;
      }
      this.form.optionList.push(item);
    },
    delItem(i) {
      if (this.form.optionList.length <= 2) {
        this.$message({
          message: "至少需要2个选项",
          type: "warning",
        });
        return;
      }
      this.form.answerList = [];
      let len = this.form.optionList.indexOf(i);
      this.form.optionList.splice(len, 1);
      this.form.optionList = this.sortArr(this.form.optionList);
      //   console.log(this.form.optionList);
    },
    isInArray(arr, item) {
      return arr.some((e) => e === item);
    },
    sortArr(arr) {
      let list = [];
      for (let i = 0; i < arr.length; i++) {
        arr[i].tag = textArr[i];
        list.push(arr[i]);
      }
      return list;
    },
    chooseQuestion(item) {
      if (!this.isEdit) return;
      if (this.form.answerList.length === 0) {
        this.form.answerList.push(item.tag);
      } else {
        if (this.isInArray(this.form.answerList, item.tag)) {
          let index = this.form.answerList.indexOf(item.tag);
          this.form.answerList.splice(index, 1);
        } else {
          this.form.answerList.push(item.tag);
        }
      }
      this.form.answerList = this.form.answerList.sort();
    },
    checkOption() {
      if (
        this.form.optionList.some((item) => {
          return item.option == "";
        })
      ) {
        this.$message.error("选项不能为空");
        return false;
      } else if (this.form.answerList.length == 0) {
        this.$message.error("请选择答案");
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.option {
  margin-top: 10px;
}
.tag {
  display: inline-block;
  width: 38px;
  text-align: center;
  line-height: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #e6e6e6;
  cursor: pointer;
}
.option_input {
  margin-left: 10px;
  width: 85%;
  vertical-align: middle;
}

.el-icon-delete {
  margin-left: 10px;
  font-size: 20px;
  color: #f56c6c;
  vertical-align: middle;
  cursor: pointer;
}
.checked_tag {
  background: #e5f1ff;
  color: #0d79ff;
  border-color: #e5f1ff !important;
}
</style>